import { Component, JSX } from "react";
import "../../../App.scss";
import IbssFooter from "../../../Components/Layout/Footer/IbssFooter";
import { appContext } from "../../../AppContext";
import { Box, Typography } from "@iconics/components";

class OutOfService extends Component
{
    private labels = appContext().labels;

    public render(): JSX.Element
    {
        return (
            <>
                <Box
                    style={{
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: '100vh',
                        padding: 'var(--spacing-sd-system-dimension-spacing-three-extra-large) var(--spacing-sd-system-dimension-spacing-none)',
                        backgroundColor: 'var(--colors-sd-system-color-component-surface)',
                    }}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Box>
                            <div style={{ backgroundColor: 'var(--colors-sd-system-color-component-surface)', borderRadius: 'var(--radii-sd-system-dimension-radius-small)' }}>
                                <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                                    <Box
                                        className="text-center"
                                        style={{ padding: 'var(--spacing-sd-system-dimension-spacing-three-extra-large)' }}
                                    >
                                        <Box
                                            style={{
                                                padding: 'var(--spacing-sd-system-dimension-spacing-two-extra-small)',
                                                gap: 'var(--spacing-sd-system-dimension-spacing-small)',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            <img src={`/images/Logos/iconics-ico-b-w.png`} style={{ height: "75px" }} alt="Iconics Roamer logo" />
                                        </Box>
                                        <Box >
                                            <Typography role='headline'>
                                                {this.labels.funcOutOfServiceTitle_S}
                                            </Typography>
                                        </Box>
                                        <Box
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <span
                                                style={{ maxWidth: "500px" }}
                                            >
                                                <Typography role="body" size="medium" inline>{this.labels.funcOutOfServiceDescription_S}</Typography>
                                            </span>
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </Box>
                    </div>
                    <IbssFooter
                        screenSize='compact'
                    />
                </Box>
            </>
        );
    }
}


export default OutOfService;
